import React from 'react';
import { Outlet } from 'react-router-dom';

import { Container, Section } from '../../../../../components';

import './Projects.scoped.scss';

const Projects = () => {
  return (
    <Container>
      <Section>
        <Outlet />
      </Section>
    </Container>
  );
};

export default Projects;
